import React, { useState, useEffect, useContext, useRef } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';

const ProfilePage = () => {

    const navigate = useNavigate();
    const { user, setUser } = useContext(UserContext);
    const [userChecked, setUserChecked] = useState(false);
    const hasFetchedUserProfileData = useRef(false);
    const [loading, setLoading] = useState(false);
    const [userProfileData, setUserProfileData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        if (!user && storedUser) {
            const parsedUser = JSON.parse(storedUser);
            if (new Date().getTime() > parsedUser.expiry) {
                localStorage.removeItem('user');
                setUser(null);
                alert('Session expired. Please log in again.');
                navigate('/login', { state: { redirectTo: `/profilepage` } });
            } else {
                setUser(parsedUser);
            }
        } else if (!user) {
            navigate('/login', { state: { redirectTo: `/profilepage` } });
        }
        setUserChecked(true);
    }, [user, setUser, navigate]);

    useEffect(() => {
        if (user) {
            hasFetchedUserProfileData.current = true;
            const fetchSessionData = async () => {
                setLoading(true);
                try {
                    const requestBody = {
                        email: user.email
                    };

                    const response = await fetch('https://3nrqnhje08.execute-api.us-east-2.amazonaws.com/api/Users/GetUserProfileData', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(requestBody),
                    });

                    if (!response.ok) {
                        throw new Error('Failed to fetch user profile data');
                    }

                    const data = await response.json();
                    if (data) {
                        setUserProfileData(data);
                    } else {
                        setError('No user profile data found or access denied.');
                    }
                } catch (err) {
                    setError(err.message);
                } finally {
                    setLoading(false);
                }
            };
            fetchSessionData();
        }
    }, [userChecked]);

    if (!userChecked || loading || (!userProfileData && !error)) {
        return <div className="loading-screen">Loading user profile data...</div>;
    }

    return (
        <div className="main-vla-container">
            <h2>User Profile</h2>
            <hr />
            <p><strong>Username:</strong> {userProfileData?.username || 'N/A'}</p>
            <p><strong>Name:</strong> {userProfileData?.firstName || 'N/A'} {userProfileData?.lastName || 'N/A'}</p>
            <p><strong>Email:</strong> {userProfileData?.email || 'N/A'}</p>
            <p><strong>Phone:</strong> {userProfileData?.phoneNumber}</p>

            <hr />

            <h2>Past Orders</h2>
            {userProfileData?.userOrders?.length > 0 ? (
                <table style={{ border: '1px solid black', width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th style={{ border: '1px solid black', padding: '10px', backgroundColor: '#f0f0f0', fontWeight: 'bold', textAlign: 'center' }}>Order Id</th>
                            <th style={{ border: '1px solid black', padding: '10px', backgroundColor: '#f0f0f0', fontWeight: 'bold', textAlign: 'center' }}>Amount</th>
                            <th style={{ border: '1px solid black', padding: '10px', backgroundColor: '#f0f0f0', fontWeight: 'bold', textAlign: 'center' }}>Status</th>
                            <th style={{ border: '1px solid black', padding: '10px', backgroundColor: '#f0f0f0', fontWeight: 'bold', textAlign: 'center' }}>Submitted</th>
                        </tr>
                    </thead>
                    <tbody>
                        {userProfileData.userOrders.map((order) => (
                            <tr key={order.orderId}>
                                <td style={{ border: '1px solid black', padding: '10px', textAlign: 'center' }}>{order.orderId}</td>
                                <td style={{ border: '1px solid black', padding: '10px', textAlign: 'center' }}>${order.amount.toFixed(2)}</td>
                                <td style={{ border: '1px solid black', padding: '10px', textAlign: 'center' }}>
                                    {order.orderStatus === 1 && 'Pending Authentication'}
                                    {order.orderStatus === 2 && 'Authenticated, Pending COA Shipment'}
                                    {order.orderStatus === 3 && 'Authenticated, COA Shipped'}
                                </td>
                                <td style={{ border: '1px solid black', padding: '10px', textAlign: 'center' }}>{new Date(order.submittedDateTime).toLocaleDateString('en-US')}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <p>No past orders found.</p>
            )}
        </div>
    );
};

export default ProfilePage;